export var getProps = _ref => {
  var {
    hovered,
    id,
    keyboardFocused,
    size,
    iconAlignment
  } = _ref;
  return {
    ids: id ? {
      root: id,
      loadingWrapper: "".concat(id, "__loading-wrapper"),
      iconWrapper: "".concat(id, "__icon-wrapper"),
      text: "".concat(id, "__text")
    } : {},
    keyboardFocused: !hovered && keyboardFocused,
    isRegular: size === 'regular',
    isSmall: size === 'small',
    isMedium: size === 'medium',
    isIconLeftAlign: iconAlignment === 'left'
  };
};
//# sourceMappingURL=getProps.js.map